import React from 'react';

interface IPlansCardFeatures {
  type: string;
  handleNewPlanChange?: any;
}

const PlansCardFeatures: React.FC<IPlansCardFeatures> = ({ type, handleNewPlanChange }) => {
  return (
    <div className='plans-card-features-container' onClick={() => handleNewPlanChange(type)}>
      {type === 'Standard' && (
        <>
          <div className='plans-card-feature-item'>
            <div className='plans-card-feature-icon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path d='M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z' stroke='#47CD89' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
            </div>
            <div className='plans-card-feature-text-wrap'>
              <div className='plans-card-feature-text-style'>
                100 Searches /month*
              </div>
            </div>
          </div>
          <div className='plans-card-feature-item'>
            <div className='plans-card-feature-icon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path d='M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z' stroke='#47CD89' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
            </div>
            <div className='plans-card-feature-text-wrap'>
              <div className='plans-card-feature-text-style'>
                75 Searches /month*
              </div>
            </div>
          </div>
          <div className='plans-card-feature-item'>
            <div className='plans-card-feature-icon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path d='M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z' stroke='#47CD89' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
            </div>
            <div className='plans-card-feature-text-wrap'>
              <div className='plans-card-feature-text-style'>
                12 Uploads /month*
              </div>
            </div>
          </div>
          <div className='plans-card-feature-item'>
            <div className='plans-card-feature-icon'>
            </div>
            <div className='plans-card-feature-text-wrap'>
              <div className='plans-card-feature-text-style'>
                -
              </div>
            </div>
          </div>
          <div className='plans-card-feature-item'>
            <div className='plans-card-feature-icon'>
            </div>
            <div className='plans-card-feature-text-wrap'>
              <div className='plans-card-feature-text-style'>
                -
              </div>
            </div>
          </div>
          <div className='plans-card-feature-item'>
            <div className='plans-card-feature-icon'>
            </div>
            <div className='plans-card-feature-text-wrap'>
              <div className='plans-card-feature-text-style'>
                -
              </div>
            </div>
          </div>
          <div className='plans-card-feature-item'>
            <div className='plans-card-feature-icon'>
            </div>
            <div className='plans-card-feature-text-wrap'>
              <div className='plans-card-feature-text-style'>
                -
              </div>
            </div>
          </div>
          <div className='plans-card-feature-item'>
            <div className='plans-card-feature-icon'>
            </div>
            <div className='plans-card-feature-text-wrap'>
              <div className='plans-card-feature-text-style'>
                -
              </div>
            </div>
          </div>
        </>
      )}
      {type === 'Pro' && (
        <>
          <div className='plans-card-feature-item'>
            <div className='plans-card-feature-icon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path d='M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z' stroke='#47CD89' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
            </div>
            <div className='plans-card-feature-text-wrap'>
              <div className='plans-card-feature-text-style'>
                175 Searches /month*
              </div>
            </div>
          </div>
          <div className='plans-card-feature-item'>
            <div className='plans-card-feature-icon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path d='M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z' stroke='#47CD89' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
            </div>
            <div className='plans-card-feature-text-wrap'>
              <div className='plans-card-feature-text-style'>
                125 Searches /month*
              </div>
            </div>
          </div>
          <div className='plans-card-feature-item'>
            <div className='plans-card-feature-icon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path d='M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z' stroke='#47CD89' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
            </div>
            <div className='plans-card-feature-text-wrap'>
              <div className='plans-card-feature-text-style'>
                30 Uploads /month*
              </div>
            </div>
          </div>
          <div className='plans-card-feature-item'>
            <div className='plans-card-feature-icon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path d='M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z' stroke='#47CD89' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
            </div>
            <div className='plans-card-feature-text-wrap'>
              <div className='plans-card-feature-text-style'>
                Up to 5
              </div>
            </div>
          </div>
          <div className='plans-card-feature-item'>
            <div className='plans-card-feature-icon'>
            </div>
            <div className='plans-card-feature-text-wrap'>
              <div className='plans-card-feature-text-style'>
                -
              </div>
            </div>
          </div>
          <div className='plans-card-feature-item'>
            <div className='plans-card-feature-icon'>
            </div>
            <div className='plans-card-feature-text-wrap'>
              <div className='plans-card-feature-text-style'>
                -
              </div>
            </div>
          </div>
          <div className='plans-card-feature-item'>
            <div className='plans-card-feature-icon'>
            </div>
            <div className='plans-card-feature-text-wrap'>
              <div className='plans-card-feature-text-style'>
                -
              </div>
            </div>
          </div>
          <div className='plans-card-feature-item'>
            <div className='plans-card-feature-icon'>
            </div>
            <div className='plans-card-feature-text-wrap'>
              <div className='plans-card-feature-text-style'>
                -
              </div>
            </div>
          </div>
        </>
      )}
      {type === 'Enterprise' && (
        <>
          <div className='plans-card-feature-item'>
            <div className='plans-card-feature-icon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path d='M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z' stroke='#47CD89' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
            </div>
            <div className='plans-card-feature-text-wrap'>
              <div className='plans-card-feature-text-style'>
                Unlimited
              </div>
            </div>
          </div>
          <div className='plans-card-feature-item'>
            <div className='plans-card-feature-icon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path d='M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z' stroke='#47CD89' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
            </div>
            <div className='plans-card-feature-text-wrap'>
              <div className='plans-card-feature-text-style'>
                Unlimited
              </div>
            </div>
          </div>
          <div className='plans-card-feature-item'>
            <div className='plans-card-feature-icon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path d='M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z' stroke='#47CD89' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
            </div>
            <div className='plans-card-feature-text-wrap'>
              <div className='plans-card-feature-text-style'>
                100 Uploads /month*
              </div>
            </div>
          </div>
          <div className='plans-card-feature-item'>
            <div className='plans-card-feature-icon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path d='M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z' stroke='#47CD89' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
            </div>
            <div className='plans-card-feature-text-wrap'>
              <div className='plans-card-feature-text-style'>
                Unlimited
              </div>
            </div>
          </div>
          <div className='plans-card-feature-item'>
            <div className='plans-card-feature-icon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path d='M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z' stroke='#47CD89' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
            </div>
            <div className='plans-card-feature-text-wrap'>
              <div className='plans-card-feature-text-style'>
                Contact Sales
              </div>
            </div>
          </div>
          <div className='plans-card-feature-item'>
            <div className='plans-card-feature-icon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path d='M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z' stroke='#47CD89' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
            </div>
            <div className='plans-card-feature-text-wrap'>
              <div className='plans-card-feature-text-style'>
                Included
              </div>
            </div>
          </div>
          <div className='plans-card-feature-item'>
            <div className='plans-card-feature-icon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path d='M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z' stroke='#47CD89' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
            </div>
            <div className='plans-card-feature-text-wrap'>
              <div className='plans-card-feature-text-style'>
                Accessible
              </div>
            </div>
          </div>
          <div className='plans-card-feature-item'>
            <div className='plans-card-feature-icon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path d='M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z' stroke='#47CD89' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
            </div>
            <div className='plans-card-feature-text-wrap'>
              <div className='plans-card-feature-text-style'>
                Included
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PlansCardFeatures;
